import React from 'react'

const ModelMonitoringDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Model Monitoring</h1>
      <p className='text-light'>
      MLGui does not have built-in model monitoring features. Model monitoring is the practice of tracking, analyzing and understanding the performance of a model over time. It often includes features like tracking model accuracy, detecting and alerting on data drift, and identifying and addressing bias in the model's predictions. Model monitoring can be an important part of maintaining and improving the performance of a deployed model over time. Some other tools such as MLflow, TensorBoard, and Databricks, among others, have built-in model monitoring features. These tools allow you to track the performance of your model over time, detect data drift, and identify and address any bias in the model's predictions.
      </p>
    </div>
  )
}

export default ModelMonitoringDoc
